/**
 * Password Generator
 *
 * Cryptographically secure random password generation using Web Crypto.
 * Generated passwords always satisfy the user form validation rules:
 * at least 8 characters with uppercase, lowercase, and number.
 */

const UPPERCASE = 'ABCDEFGHJKLMNPQRSTUVWXYZ' // excludes I, O (ambiguous)
const LOWERCASE = 'abcdefghijkmnpqrstuvwxyz' // excludes l, o (ambiguous)
const NUMBERS = '23456789' // excludes 0, 1 (ambiguous)
const SYMBOLS = '!@#$%&*+-=?'

/**
 * Pick a random character from a string using crypto randomness
 */
function randomChar(charset) {
  const values = new Uint32Array(1)
  crypto.getRandomValues(values)
  return charset[values[0] % charset.length]
}

/**
 * Generate a secure random password
 * @param {number} length - Password length (default 16, minimum 8)
 * @returns {string} Generated password with at least one uppercase, lowercase, number, and symbol
 */
export function generatePassword(length = 16) {
  const finalLength = Math.max(length, 8)
  const allChars = UPPERCASE + LOWERCASE + NUMBERS + SYMBOLS

  // Guarantee one character from each required class
  const chars = [
    randomChar(UPPERCASE),
    randomChar(LOWERCASE),
    randomChar(NUMBERS),
    randomChar(SYMBOLS)
  ]

  while (chars.length < finalLength) {
    chars.push(randomChar(allChars))
  }

  // Fisher-Yates shuffle with crypto randomness so required chars aren't always first
  for (let i = chars.length - 1; i > 0; i--) {
    const values = new Uint32Array(1)
    crypto.getRandomValues(values)
    const j = values[0] % (i + 1)
    ;[chars[i], chars[j]] = [chars[j], chars[i]]
  }

  return chars.join('')
}
